import React from "react";
import { ArrowRight } from "lucide-react";

const CTAButton = ({ label = "QUERO VENDER NO TIKTOK", href = "#preco", target }) => {
  return (
    <a href={href} target={target} className="cta-btn">
      <span className="pill">{label}</span>
      <span className="arrow"><ArrowRight size={20} strokeWidth={2.5} /></span>
    </a>
  );
};

export default CTAButton;
